import React, { useMemo, useState } from 'react'
import { Alert } from 'react-bootstrap'
import classNames from 'classnames'
import { Spinner } from '../../../components/Spinner/Spinner'
import { CustomWorkflowSummary, useListCustomWorkflowsQuery, useListEnabledCustomWorkflowsQuery } from '../../../store/customWorkflow/customWorkflows'
import { RecommendedWorkflowCard } from './RecommendedWorkflowCard'
import { EnableWorkflowModal } from './EnableWorkflowModal'
import styles from '../Workflows.module.scss'

interface RecommendedWorkflowsProps {
  accountId: string
  active: boolean
}

export const RecommendedWorkflows: React.FC<RecommendedWorkflowsProps> = ({ accountId, active }) => {
  const { data: workflows, isLoading, isError } = useListCustomWorkflowsQuery({ accountId, triggerType: 'event' }, { skip: !active })
  const { data: enabled, isLoading: enabledLoading, isError: enabledError } = useListEnabledCustomWorkflowsQuery({ accountId }, { skip: !active })
  const [selected, setSelected] = useState<CustomWorkflowSummary | null>(null)

  const enablementByWorkflowId = useMemo(() => {
    const map = new Map<string, string>()
    for (const record of enabled ?? []) {
      map.set(record.customWorkflowId, record.id)
    }
    return map
  }, [enabled])

  if (isLoading || enabledLoading) {
    return (
      <div className='d-flex justify-content-center py-5'>
        <Spinner />
      </div>
    )
  }
  if (isError || enabledError) {
    return <Alert variant='warning'>Could not load workflows.</Alert>
  }
  if (!workflows?.length) {
    return <div className='py-5 text-center zocks-text-gray-600'>No workflows available yet.</div>
  }

  return (
    <>
      <div className={classNames('d-grid gap-3 align-items-start w-100', styles.tileGrid)}>
        {workflows.map((workflow) => (
          <RecommendedWorkflowCard
            key={workflow.id}
            workflow={workflow}
            enabled={enablementByWorkflowId.has(workflow.id)}
            onClick={() => setSelected(workflow)}
          />
        ))}
      </div>
      {selected ? (
        <EnableWorkflowModal
          accountId={accountId}
          workflow={selected}
          enablementId={enablementByWorkflowId.get(selected.id) ?? null}
          show={!!selected}
          onHide={() => setSelected(null)}
        />
      ) : null}
    </>
  )
}
